import React, { useState, useEffect } from 'react'
// import { FaCoffee } from "react-icons/fa"
import './StarRating.scss'
import firebase from '../util/firebase.js';
import { useAuth } from "../util/auth.js";
import { useRouter } from "./../util/router.js";
// import { useDocumentData } from 'react-firebase-hooks/firestore';
import { ReactComponent as CoffeeBean } from './icons/CoffeeBean.svg';

function StarRating(props) {
    const auth = useAuth();
    const router = useRouter();    
    const [hover, setHover] = useState(null);

    console.log("star rating has rendered")

    const { coffee: {
      coffeeName,
      coffeeProductUrl,
      coffeeCountry,
      coffeeRegion,
      growingRegion,
      coffeeCompany,
      tastingNotes,
      coffeeFlavor,
      coffeeCultivar,
      coffeeType,
      coffeeProcess,
      coffeePrice,
      coffeeBagSize,
      roasterLocation,
      ratingClicked,      
      // coffeeRatingTotalAdj,
      // coffeeReviewsNumTotalAdj,
      // coffeeReviewsNumTotal,
      coffeeId,
      coffeeImgUrl}} = props;        

      // const ratedDocQuery = firebase.firestore().doc(`/coffee/${coffeeId}/ratings/${firebase.auth().currentUser.uid}_${coffeeId}`);
      // const [ratedDoc] = useDocumentData(ratedDocQuery, { idField: 'id' });

       //sets the state with props.ratingClicked
       const [rating, setRating] = useState(ratingClicked);   

      useEffect(() => {
        const getRatedValue = async () => {
          if (firebase.auth().currentUser && !rating) {
          const ratedRef = firebase.firestore().doc(`/coffee/${coffeeId}/ratings/${firebase.auth().currentUser.uid}_${coffeeId}`);
            await ratedRef.onSnapshot(function(doc) {
            if (doc.exists) {
              setRating(doc.data().ratingClicked);
              console.log("Data pull for your current rating in starRating has executed");
            }
          })}
        };
        getRatedValue();
        // eslint-disable-next-line
      }, []);
      

    const handleClickRating = (index) => {
      //push to signup page if not logged in
      if (!auth.user) {
        router.push("/auth/signup")

      //allows user to delete rating if they click on the same star that is already selected
      } else if      
        (index === rating) {
          setRating(null);
          setHover(null);
          deleteRatedCoffee(index);

      } else if
        (rating > 0) {
          setRating(index);
          updateRating(index);
      } 
      else {
        setRating(index);
        createRating(index);
      };
        }

      const createRating = async (index) => {
        const userRef = firebase.firestore().collection('users').doc(auth.user.id);
        const coffeeRef = firebase.firestore().collection('coffee').doc(coffeeId);
        const ratingsRef = firebase.firestore().collection('coffee').doc(coffeeId).collection('ratings').doc(`${auth.user.id}_${coffeeId}`);
        try {
          await firebase.firestore().runTransaction(async t => {
            //read
            const userDoc = await t.get(userRef);
              const userReviewWeight = userDoc.data().reviewWeight;
              const userReviewAvgFactor = userDoc.data().reviewAvgFactor;
              const oldUserRatingTotal = userDoc.data().userRatingTotal;
              const oldUserReviewsNumTotal = userDoc.data().userReviewsNumTotal;
              const userReviewWeightAdj = (userReviewWeight * userReviewAvgFactor);
              const userRatingAdj = (index * userReviewWeight * userReviewAvgFactor);
            //logic to calculate new values
              const newUserRatingTotal = oldUserRatingTotal + index;
              const newUserReviewsNumTotal = oldUserReviewsNumTotal + 1;

            //read  
            const coffeeDoc = await t.get(coffeeRef);
              const oldCoffeeReviewsNumTotal  = coffeeDoc.data().coffeeReviewsNumTotal;
              const oldCoffeeRatingTotalAdj = coffeeDoc.data().coffeeRatingTotalAdj;
              const oldCoffeeReviewsNumTotalAdj = coffeeDoc.data().coffeeReviewsNumTotalAdj;
            //logic to calculate new values
              const newCoffeeReviewsNumTotal = oldCoffeeReviewsNumTotal + 1
              const newCoffeeRatingTotalAdj = oldCoffeeRatingTotalAdj + userRatingAdj;
              const newCoffeeReviewsNumTotalAdj = oldCoffeeReviewsNumTotalAdj + userReviewWeightAdj;


            //write
            await t.update(userRef, {
              userRatingTotal: newUserRatingTotal,
              userReviewsNumTotal: newUserReviewsNumTotal,
              userRatingAvg: newUserRatingTotal / newUserReviewsNumTotal,
            });
            
            await t.update(coffeeRef, {
              coffeeReviewsNumTotal: newCoffeeReviewsNumTotal,
              coffeeRatingTotalAdj: newCoffeeRatingTotalAdj,
              coffeeReviewsNumTotalAdj: newCoffeeReviewsNumTotalAdj,
              coffeeReviewAvg: newCoffeeRatingTotalAdj/newCoffeeReviewsNumTotalAdj,
            });

            await t.set(ratingsRef, {
              coffeeId: coffeeId,
              coffeeName: coffeeName,
              coffeeProductUrl: coffeeProductUrl,
              coffeeCountry: coffeeCountry,
              coffeeRegion: coffeeRegion,
              growingRegion: growingRegion,
              coffeeCompany: coffeeCompany,
              tastingNotes: tastingNotes,
              coffeeFlavor: coffeeFlavor,
              coffeeCultivar: coffeeCultivar,
              coffeeType: coffeeType,
              coffeeProcess: coffeeProcess,
              coffeePrice: parseFloat(coffeePrice),
              coffeeBagSize: parseFloat(coffeeBagSize),
              roasterLocation: roasterLocation,
              coffeeRatingTotalAdj: newCoffeeRatingTotalAdj,
              coffeeReviewsNumTotalAdj: newCoffeeReviewsNumTotalAdj,
              coffeeReviewsNumTotal: newCoffeeReviewsNumTotal,
              coffeeReviewAvg: newCoffeeRatingTotalAdj/newCoffeeReviewsNumTotalAdj,
              userReviewsNumTotal: newUserReviewsNumTotal,
              coffeeImgUrl: coffeeImgUrl,
              ratingClicked: index,
              userRatingAdj: userRatingAdj,
              userReviewWeightAdj: userReviewWeightAdj,
              userReviewWeight: auth.user.reviewWeight,
              userReviewAvgFactor: auth.user.reviewAvgFactor,
              createdTime: firebase.firestore.FieldValue.serverTimestamp(),
              uid: auth.user.id,  
          })

            console.log("createTransaction has executed successfully")
          })
        } catch (e){
          console.log("createTransaction failure:", e)
        }
      }

      const updateRating = async (index) => {
        const userRef = firebase.firestore().collection('users').doc(auth.user.id);
        const coffeeRef = firebase.firestore().collection('coffee').doc(coffeeId);
        const ratingsRef = firebase.firestore().collection('coffee').doc(coffeeId).collection('ratings').doc(`${auth.user.id}_${coffeeId}`);

        try {
          await firebase.firestore().runTransaction(async t => {
            //read
            const userDoc = await t.get(userRef);
              const userReviewWeight = userDoc.data().reviewWeight;
              const userReviewAvgFactor = userDoc.data().reviewAvgFactor;
              const oldUserRatingTotal = userDoc.data().userRatingTotal;
              const oldUserReviewsNumTotal = userDoc.data().userReviewsNumTotal;
              const userReviewWeightAdj = (userReviewWeight * userReviewAvgFactor)
              const userRatingAdj = (index * userReviewWeight * userReviewAvgFactor);

            //read
            const ratingsDoc = await t.get(ratingsRef);
              // const oldUserReviewValueAdjusted = ratingsDoc.data().userReviewValueAdjusted;
              const oldUserReviewWeightAdj = ratingsDoc.data().userReviewWeightAdj;
              const oldRatingClicked = ratingsDoc.data().ratingClicked;
              const oldUserRatingAdj = ratingsDoc.data().userRatingAdj
              // //new coffee adjust rating - old coffee adjust rating = diff to increment
              // const diffCoffeeRatingTotalAdj= ((userRatingAdj) - (oldUserReviewValueAdjusted));
              // //new coffee reviews adj - old coffee reviews adj = the difference of total reviews adj
              // const diffOldCoffeeReviewsNumTotalAdj = ((userReviewWeightAdj) - (oldUserReviewWeightAdj));
              // //new rating - old rating = diff to increment
              // const diffUserReviewValueClicked = ((index) - (oldReviewValueClicked));
              
            //read
            const coffeeDoc = await t.get(coffeeRef);
              const oldCoffeeReviewsNumTotal = coffeeDoc.data().coffeeReviewsNumTotal;
              const oldCoffeeRatingTotalAdj = coffeeDoc.data().coffeeRatingTotalAdj;
              const oldCoffeeReviewsNumTotalAdj = coffeeDoc.data().coffeeReviewsNumTotalAdj;
            
              //logic to calculate new values
            const newUserRatingTotal = (oldUserRatingTotal - oldRatingClicked) + index;
            const newCoffeeRatingTotalAdj = (oldCoffeeRatingTotalAdj - oldUserRatingAdj) + userRatingAdj;
            const newCoffeeReviewsNumTotalAdj = (oldCoffeeReviewsNumTotalAdj - oldUserReviewWeightAdj) + userReviewWeightAdj;

            //write
            await t.update(userRef, {
              //update user profile with difference of new review value - old review value
              // userRatingTotal: firebase.firestore.FieldValue.increment(diffUserReviewValueClicked),
              userRatingTotal: newUserRatingTotal,
              userRatingAvg: newUserRatingTotal / oldUserReviewsNumTotal,
            });

            await t.update(coffeeRef, {
              coffeeRatingTotalAdj: newCoffeeRatingTotalAdj,
              coffeeReviewsNumTotalAdj: newCoffeeReviewsNumTotalAdj,
              coffeeReviewAvg: newCoffeeRatingTotalAdj/newCoffeeReviewsNumTotalAdj,
            });

            await t.set(ratingsRef, {
              coffeeId: coffeeId,
              coffeeName: coffeeName,
              coffeeProductUrl: coffeeProductUrl,
              coffeeCountry: coffeeCountry,
              coffeeRegion: coffeeRegion,
              growingRegion: growingRegion,
              coffeeCompany: coffeeCompany,
              tastingNotes: tastingNotes,
              coffeeFlavor: coffeeFlavor,
              coffeeCultivar: coffeeCultivar,
              coffeeType: coffeeType,
              coffeeProcess: coffeeProcess,
              coffeePrice: parseFloat(coffeePrice),
              coffeeBagSize: parseFloat(coffeeBagSize),
              roasterLocation: roasterLocation,
              coffeeRatingTotalAdj: newCoffeeRatingTotalAdj,
              coffeeReviewsNumTotalAdj: newCoffeeReviewsNumTotalAdj,
              coffeeReviewsNumTotal: oldCoffeeReviewsNumTotal,
              coffeeReviewAvg: newCoffeeRatingTotalAdj/newCoffeeReviewsNumTotalAdj,
              userReviewsNumTotal: oldUserReviewsNumTotal,
              coffeeImgUrl: coffeeImgUrl,
              ratingClicked: index,
              userRatingAdj: userRatingAdj,
              userReviewWeightAdj: userReviewWeightAdj,
              userReviewWeight: auth.user.reviewWeight,
              userReviewAvgFactor: auth.user.reviewAvgFactor,
              createdTime: firebase.firestore.FieldValue.serverTimestamp(),
              uid: auth.user.id,   
          })

            console.log("updateRating transaction has run in starRating")
          })
        } catch (e){
          console.log("updateRating failure:", e)
        }
      }

        const deleteRatedCoffee = async (index) => {
          const userRef = firebase.firestore().collection('users').doc(auth.user.id);
          const coffeeRef = firebase.firestore().collection('coffee').doc(coffeeId);
          const ratingsRef = firebase.firestore().collection('coffee').doc(coffeeId).collection('ratings').doc(`${auth.user.id}_${coffeeId}`);          
  
          try {
            await firebase.firestore().runTransaction(async t => {
              //read
              const userDoc = await t.get(userRef);
                const oldUserReviewsNumTotal = userDoc.data().userReviewsNumTotal;
                const oldUserRatingTotal = userDoc.data().userRatingTotal;
  
              //read
               const ratingsDoc = await t.get(ratingsRef);
                const oldUserRatingAdj = ratingsDoc.data().userRatingAdj;
                const oldUserReviewWeightAdj = ratingsDoc.data().userReviewWeightAdj;
                const oldRatingClicked = ratingsDoc.data().ratingClicked;

              //read
               const coffeeDoc = await t.get(coffeeRef);
                const oldCoffeeReviewsNumTotal = coffeeDoc.data().coffeeReviewsNumTotal;
                const oldCoffeeRatingTotalAdj = coffeeDoc.data().coffeeRatingTotalAdj;
                const oldCoffeeReviewsNumTotalAdj = coffeeDoc.data().coffeeReviewsNumTotalAdj;

              //logic to create new Values
                const newUserRatingTotal = oldUserRatingTotal - oldRatingClicked;
                const newUserReviewsNumTotal = oldUserReviewsNumTotal - 1;
                const newCoffeeReviewsNumTotal = oldCoffeeReviewsNumTotal - 1
                const newCoffeeRatingTotalAdj = oldCoffeeRatingTotalAdj - oldUserRatingAdj;
                const newCoffeeReviewsNumTotalAdj = (oldCoffeeReviewsNumTotalAdj - oldUserReviewWeightAdj);

              //write
              await t.update(userRef, {                
                userReviewsNumTotal: newUserReviewsNumTotal,
                userRatingTotal: newUserRatingTotal,
                userRatingAvg: newUserRatingTotal / newUserReviewsNumTotal,
              });
              
              await t.update(coffeeRef, {
                coffeeReviewsNumTotal: newCoffeeReviewsNumTotal,
                coffeeRatingTotalAdj: newCoffeeRatingTotalAdj,
                coffeeReviewsNumTotalAdj: newCoffeeReviewsNumTotalAdj,
                coffeeReviewAvg: newCoffeeRatingTotalAdj/newCoffeeReviewsNumTotalAdj,
              });

              await t.delete(ratingsRef)

            console.log("deleteRating transaction has run in starRating")
            })
          } catch (e){
            console.log("deleteRating failure:", e)
          }
        }
        

    return (

        <div className="star-rating">
        {[...Array(5)].map((star, index) => {
          index += 1;
          return (
            <button
              type="radio"
              key={index}
              className={index <= (hover || rating) ? "on" : "off"}
              onClick={() => handleClickRating(index)}
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(rating)}
            >
              <CoffeeBean className="star" height="1.5em" width="1.5em" />
            </button>
          );
        })}

      </div>
    )
}

export default StarRating